export default __webpack_public_path__ + "static/media/certification2.3d43457b.jpg";